import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Sparkles } from "lucide-react";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Idempotency guard for StrictMode double mount
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    apiClient
      .post("/auth/session", null, {
        headers: { "X-Session-ID": sessionId },
        withCredentials: true,
      })
      .then((r) => {
        setUser(r.data);
        // Clear hash and navigate to admin
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user: r.data } });
      })
      .catch((e) => {
        const msg = e.response?.data?.detail || "Giriş başarısız";
        toast.error(msg);
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4"
          style={{ background: "linear-gradient(135deg, #B39B7A, #8B9B88)" }}>
          <Sparkles className="w-7 h-7 text-white" />
        </div>
        <Loader2 className="w-5 h-5 animate-spin mx-auto text-primary mb-2" />
        <p className="text-sm text-muted-foreground font-display">Oturum doğrulanıyor...</p>
      </div>
    </div>
  );
}
